import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';
import Loader from '@cpg-its/ads.common.loading-circle';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { useInstitutionSetting } from '../../../components/use-institution-settings';
import { ArcRoutes } from '../../../constants/routes';
import { InstitutionState } from '../institution-model';
import { setCurrentInstitution, setInstitutionSurveyStatus } from '../institution-slice';
import { InstitutionSurveyForm } from './institution-survey-form';
import { parseChanged } from '../../../../../global/helpers/form-data-helper';
import { InstitutionSurveyFormModel } from './institution-survey-model';
import { patchOrganization } from '../../../../../global/ducks/organization-prc-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { Yes } from '../../../constants/constant-strings';

function InstituionSurvey() {

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const settings = useInstitutionSetting();
	const dispatch = useDispatch();

	const onSuccess = (response) => {
		dispatch((setCurrentInstitution(response?.data)));
		dispatch((setInstitutionSurveyStatus(ApiStatuses.Success)));
	};

	const onSubmitHandler = (initialValue: InstitutionSurveyFormModel, updated: InstitutionSurveyFormModel) => {
		dispatch(apiErrorClear());
		dispatch((setInstitutionSurveyStatus(ApiStatuses.None)));

		const toUpdate = parseChanged(initialValue, updated);
		if (toUpdate.lay_pension_plan_type) toUpdate.provides_lay_pension_plan = Yes;
		dispatch(patchOrganization(institutionState?.currentInstitution?.org_client_nbr, toUpdate, onSuccess));
	};

	const institutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionSearch}`);
	const { state } = useLocation<any>();

	useEffect(() => {
		dispatch(apiErrorClear());
		dispatch(setInstitutionSurveyStatus(ApiStatuses.None));
	}, []);

	if (!institutionState?.institutionClientNumber) {
		return (
			<Redirect to=
				{
					{
						pathname: institutionSelect,
						state,
					}
				}
			/>);
	}

	if (!institutionState?.currentInstitution) {
		return (<Loader />);
	}


	return (
		<>
			<InstitutionSurveyForm
				formHeader={settings?.institutionSurveytitle}
				formDescription={settings?.institutionSurveyDescription}
				onSubmitHandler={onSubmitHandler}
				institutionDetail={institutionState?.currentInstitution}
			/>
		</>
	);
}

export default InstituionSurvey;